<template>
  <Header />
  <div class="title-container">
    <h1>{{ $labels.project }}s</h1>

    <div class="filter-container">
    </div>
  </div>

  <div class="container-fluid-project">
    <vue-good-table :columns="columns" :rows="processedRows" :pagination-options="{
      enabled: true,
      perPage: perPage
    }" :search-options="{ enabled: false }" :sort-options="{ enabled: true }">
      <template #table-row="props">
        <!-- Product ID -->
        <span v-if="props.column.field === 'product_id'">
          <span :title="props.row.product_name">
            {{ props.row.product_name }}
          </span>
        </span>
        <!-- Logbooks (one per line) -->
        <span v-else-if="props.column.field === 'logbooks'">
          <div v-for="lb in props.row.logbooks" :key="lb.logbook_id">
            {{ lb.name }}
          </div>
        </span>
          <!-- Instructors -->
          <span v-else-if="props.column.field === 'instructor_ids'">
            <span :title="props.row.instructor_names_display">
              {{ props.row.instructor_ids_display }}
            </span>
          </span>
          <!-- Status -->
          <span v-else-if="props.column.field === 'status'">
            <span
              :class="[
                'status-badge',
                  props.row.locked
                    ? 'status-locked-badge'
                    : 'status-active-badge'
              ]"
            >
              {{ props.row.locked ? 'Locked' : 'Active' }}
            </span>
          </span>
        <!-- Actions -->
        <span v-else-if="props.column.field === 'actions'" class="center-icons">
          <font-awesome-icon
            icon="edit"
            class="edit-icon"
            :title="`Edit ${this.$labels.project}`"
            @click="viewEditProject(props.row)"
          />
          <font-awesome-icon
            v-if="props.row.is_complete"
            icon="history"
            class="history-icon"
            :title="`View task list at start date`"
            @click="viewTaskList(props.row.product_id, props.row.project_id, props.row.start_date)"
          />
          <font-awesome-icon icon="trash-alt" class="delete-icon" :title="`Delete ${this.$labels.project}`"
            @click="deleteProject(props.row.project_id)" />
        </span>
        <!-- Default cell -->
        <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
  <div>
    <button class="btn btn-primary rounded" id=addProjectButton @click="viewAddProject">Add {{ $labels.project }}</button>
  </div>
  <edit-project-modal v-if="showEditProject" :status="selectedProjectStatus" :project="selectedProject" :assigned-users="selectedProjectUsers"
    @close="closeEditProject"></edit-project-modal>
  <add-project-modal v-if="showAddProject" @close="closeAddProject"></add-project-modal>
  <assign-trainee-modal v-if="showAssignTraineeModal" :selectedProjectId="selectedProjectId"
    :status="selectedProjectStatus" @close="closeAssignTraineeModal"></assign-trainee-modal>
  <assign-instructor-modal v-if="showAssignInstructorModal" :selectedProjectId="selectedProjectId"
    :status="selectedProjectStatus" @close="closeAssignInstructorModal"></assign-instructor-modal>
  <task-list-modal v-if="showTaskList" :tasks="tasksAtDate" :project="selectedProject" :product="selectedProduct" @close="closeTaskList"></task-list-modal>
  
</template>

<script>
import Header from '../Header.vue';
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import EditProjectModal from './EditProjectModal.vue';
import AddProjectModal from './AddProjectModal.vue';
import AssignTraineeModal from './AssignTraineeModal.vue';
import AssignInstructorModal from './AssignInstructorModal.vue';
import TaskListModal from './ViewTaskListModal.vue';

export default {
  name: 'ViewProjects',

  components: {
    VueGoodTable,
    Header,
    EditProjectModal,
    AddProjectModal,
    AssignTraineeModal,
    AssignInstructorModal,
    TaskListModal,
  },

  data() {
    return {
      user_id: parseInt(localStorage.getItem('user_id')),
      role: localStorage.getItem('role'),
      projects: [],
      products: [],
      instructors: [],
      users: [],
      perPage: 10,
      showEditProject: false,
      showAddProject: false,
      showTaskList: false,
      assignedToMeOnly: false,
      showTasksAtDateModal: false,
      selectedProjectId: null,
      selectedProjectStatus: null,
      tasksAtDate: [],
      tasksAtDateLoading: false,
      tasksAtDateError: null,
      selectedProject: null,
      selectedProduct: null,
    };
  },
  computed: {
    columns() {
      return [
        { label: 'ID', field: 'project_id', sortable: true, thClass: 'vgt-id-column', tdClass: 'vgt-id-column' },
        { 
          label: 'Name', 
          field: 'name', 
          sortable: true, 
          thClass: 'vgt-project-name-column', 
          tdClass: 'vgt-project-name-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        { 
          label: `${this.$labels.product}`, 
          field: 'product_id', 
          sortable: true, 
          thClass: 'vgt-project_name-column', 
          tdClass: 'vgt-project_name-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueProductOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue) === String(filterValue);
            }
          } 
        },
        { 
          label: 'Start Date', 
          field: 'start_date', 
          sortable: true, 
          thClass: 'vgt-date-column', 
          tdClass: 'vgt-date-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        { 
          label: 'End Date', 
          field: 'end_date', 
          sortable: true, 
          thClass: 'vgt-date-column', 
          tdClass: 'vgt-date-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        { 
          label: 'Location', 
          field: 'location', 
          sortable: true, 
          thClass: 'vgt-location-column', 
          tdClass: 'vgt-location-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        { 
          label: 'Instructor ID(s)', 
          field: 'instructor_ids', 
          sortable: false, 
          thClass: 'vgt-multi-id-column', 
          tdClass: 'vgt-multi-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueInstructorOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return Array.isArray(rowValue) && rowValue.includes(String(filterValue));
            }
          }
        },
        { 
          label: 'Status', 
          field: 'status', 
          sortable: false, 
          thClass: 'vgt-status-column', 
          tdClass: 'vgt-status-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: [
              { value: 'active', text: 'Active' },
              { value: 'inactive', text: 'Locked' }
            ],
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return rowValue === filterValue;
            }
          }
        },
        { label: 'Actions', field: 'actions', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' }
      ];
    },
    uniqueProductOptions() {
      const usedProductIds = [...new Set(this.projects.map(p => p.product_id).filter(Boolean))];

      return usedProductIds.map(id => {
        const product = this.products.find(p => String(p.product_id) === String(id));
        return {
          value: String(id),
          text: product ? product.name : `${this.$labels.product} ${id}`
        };
      });
    },
    uniqueInstructorOptions() {
      const usedInstructorIds = [...new Set(this.instructors.map(i => i.user_id).filter(Boolean))];

      return usedInstructorIds.map(id => {
        const instructor = this.instructors.find(i => String(i.user_id) === String(id));
        return {
          value: String(id),
          text: instructor
            ? `${instructor.last_name}, ${instructor.first_name}`
            : `Instructor ${id}`
        };
      });
    },
    processedRows() {
      const myId = Number(this.user_id);

      return this.projects
        .filter(project => {
          const assignedToMeMatch =
            !this.assignedToMeOnly ||
            this.instructors.some(
              ins =>
                ins.project_id === project.project_id &&
                Number(ins.user_id) === myId
            );

          return assignedToMeMatch;
        })
        .map(project => {
          const product = this.products.find(
            p => String(p.product_id) === String(project.product_id)
          );

          const projectInstructors = this.instructors.filter(
            ins => ins.project_id === project.project_id
          );

          return {
            ...project,
            status: project.locked ? 'locked' : 'active',
            product_name: product ? product.name : `${this.$labels.product} ${project.product_id}`,
            instructor_ids: projectInstructors.map(ins => String(ins.user_id)),
            instructor_ids_display: projectInstructors.map(ins => ins.user_id).join(', '),
            instructor_names_display: projectInstructors.length
              ? projectInstructors.map(ins => `${ins.last_name}, ${ins.first_name}`).join(' | ')
              : 'Unknown Instructor',
          };
        });
    },
    selectedProjectUsers() {
      if (!this.selectedProject) return [];

      return this.users.filter(user =>
        String(user.project_id) === String(this.selectedProject.project_id)
      );
    },
  },
  methods: {
    async fetchProjects() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        let result = await axios.get('/api/projects', { headers });
        this.projects = result.data;

        console.log(this.projects)

        // Extract and populate unique product names
        let productResult = await axios.get('/api/products', { headers });
        this.products = productResult.data;

        const usersRes = await axios.get('/api/users', { headers });
        const projectsRes = await axios.get(`/api/user/projects`, { headers });

        const users = usersRes.data;
        const userProjects = projectsRes.data.user_projects;
        const userById = new Map(users.map(u => [u.user_id, u]));

        this.users = userProjects.map(s => ({
          ...userById.get(s.user_id), // base user fields (email, license_no, etc.)
          ...s,                       // project fields override/add (role, project_id...)
        }));

        // Filter instructors and trainees
        this.instructors = this.users.filter(user => user.role === 'instructor');
        this.trainees = this.users.filter(user => user.role === 'trainee');
        console.log('instructors', this.instructors);
        console.log('trainees', this.trainees);

        this.totalPages = Math.ceil(this.projects.length / this.perPage);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
    viewEditProject(project) {
      localStorage.setItem('project_id', project.project_id);
      this.selectedProject = project;
      this.selectedProjectStatus = project.locked;
      this.showEditProject = true;
    },
    closeEditProject() {
      this.showEditProject = false; // Close the modal
      this.fetchProjects();
    },
    viewAddProject() {
      this.showAddProject = true; // Show the modal when the button is clicked
    },
    closeAddProject() {
      this.showAddProject = false; // Close the modal
      this.fetchProjects();
    },
    async viewTaskList(product_id, project_id, start_date) {
      this.tasksAtDate = [];
      this.tasksAtDateError = null;
      this.tasksAtDateLoading = true;
      this.showTaskList = true;

      this.selectedProduct = this.products.find(p => String(p.product_id) === String(product_id)) || null;
      this.selectedProject = this.projects.find(p => String(p.project_id) === String(project_id)) || null; 


      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.get(`/api/products/${product_id}/tasks/at-date`, {
          headers,
          params: { date: start_date },
        });

        this.tasksAtDate = response.data;
      } catch (error) {
        console.error('Error fetching tasks at date:', error);
        this.tasksAtDateError = 'Failed to load tasks. Please try again.';
      } finally {
        this.tasksAtDateLoading = false;
      }
    },
    closeTaskList() {
      this.showTaskList = false; // Close the modal
    },
    async deleteProject(id) {
      if (!confirm(`Are you sure you want to delete this ${this.$labels.project}?`)) return;
      if (!confirm(`This action will PERMANENTLY delete the ${this.$labels.project} from the database. Do you wish to continue?`)) return;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const response = await axios.delete(`/api/projects/${id}`, { headers });

        if (response.status === 200) {
          // await removeItemFromCacheByUrl(`/api/projects/${id}`);
          this.projects = this.projects.filter(a => String(a.project_id) !== String(id));
          window.alert(`${this.$labels.project} deleted successfully`);
        }
      } catch (error) {
        if (error.isOffline === true && error.queued) {
          this.projects = this.projects.filter(a => String(a.project_id) !== String(id));
          alert('You are offline. The delete has been queued and will sync later.');
          return;
        }

        const msg = error.response?.data?.message || '';
        if (msg.includes('SQLSTATE[23000]') && msg.includes('1451')) {
          alert(`This project cannot be deleted because it is linked to a ${this.$labels.product}.`);
        } else {
          alert('An error occurred while deleting.');
        }
      }
    },
  },
  async mounted() {
    this.fetchProjects();
  },
}
</script>


<style scoped>
.container-fluid-project {
  padding-top: 10px;
  width: 97%;
  margin-left: 1.5%;
  margin-right: 1.5%;
  display: flex;
  justify-content: center;
}

button.btn#addProjectButton {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 15px;
  margin-right: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
}

button.btn#addProjectButton:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

h1 {
  padding-top: 0px;
  padding-left: 3%;
}

label {
  margin-top: 8px;
}

.pagination-container {
  margin-top: 40px;
  margin-bottom: 0;
  display: flex;
  margin-left: 3%;
}

.edit-icon {
  font-size: 16px;
  color: #615f5f;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  margin-left: 8px;
  margin-right: 8px;
}

.edit-icon:hover {
  color: #2b2a2a;
  cursor: pointer;
  transform: scale(1.1);
}

.icon-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.icon-disabled:hover {
  opacity: 0.3;
  cursor: not-allowed;
}


.delete-icon {
  font-size: 16px;
  color: #FF0000;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  margin-left: 8px;
  margin-right: 8px;
}

.delete-icon:hover {
  color: #a82222;
  cursor: pointer;
  transform: scale(1.1);
}

input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}

select {
  padding: 5px;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px !important;
  color: #fff;
}

/* Locked = red */
.status-locked-badge {
  background: #dc3545;
}

/* Active = green */
.status-active-badge {
  background: #28a745;
}

.status-completed-badge {
  background: #398dec;
}

.status-badge:hover {
  opacity: 0.9;
  cursor: default; 
  color: white !important;
}

.history-icon {
  color: rgb(33, 71, 238);
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.history-icon:hover {
  color: rgb(25, 55, 187);
  cursor: pointer;
  transform: scale(1.1);
}
</style>